import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ICreditCardDTO } from '../../../../models/ICreditCardDTO';
import { faPenToSquare, faTrashCan, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { ConfirmationService } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { Avatar } from "primeng/avatar";

interface EditModeData {
  isWeb: boolean;
  value: boolean;
}
@Component({
  selector: 'app-credit-card-item',
  imports: [CommonModule, FormsModule, FaIconComponent, TagModule, Avatar],
  templateUrl: './credit-card-item.component.html',
  styleUrl: './credit-card-item.component.scss'
})
export class CreditCardItemComponent {

  protected readonly confirmationService = inject(ConfirmationService);
  
  faTrashCan = faTrashCan;
  faPenToSquare = faPenToSquare;
  faSquare = faSquare;
  faSquareCheck = faSquareCheck

  @Input() isWebComponent: boolean = false;
  @Input() isEditing: boolean = false;
  @Input() showCheckBox: boolean = false;
  @Input() isAlwaysVisibleCheckBox: boolean = false;
  @Input() cardNumberFormValue!: String;
  @Input() cardHolderFormValue!: String;
  @Input() monthFormValue!: String;
  @Input() yearFormValue!: String;
  @Input() card: ICreditCardDTO | null = null;
  
  @Input() selectedCard! : ICreditCardDTO | null ; 

  @Output() onSelectCardWeb: EventEmitter<ICreditCardDTO> = new EventEmitter<ICreditCardDTO>();
  @Output() onSelectCardMobile: EventEmitter<ICreditCardDTO> = new EventEmitter<ICreditCardDTO>();
  @Output() onCheckboxChange: EventEmitter<ICreditCardDTO> = new EventEmitter<ICreditCardDTO>();
  @Output() turnEditMode: EventEmitter<EditModeData> = new EventEmitter();
  @Output() confirmDelete: EventEmitter<ICreditCardDTO> = new EventEmitter();
  
  onSelectCard(card: ICreditCardDTO){
    if(this.isWebComponent){
      this.onSelectCardWeb.emit(card);
    }else{
      this.onSelectCardMobile.emit(card);
    }
  }
  onEditCard(card: ICreditCardDTO){
    const data: EditModeData = { isWeb: this.isWebComponent, value: true };
    this.turnEditMode.emit(data);
  }

  onChildCheckboxChange(card: ICreditCardDTO){
    this.onCheckboxChange.emit(card)
  }

  format(value : string, pattern :string) {
    let i = 0;
    let patternSize = 0;
    if(value.length>=12){
      patternSize = value.length + 3;
    }else if(value.length>=8){
      patternSize = value.length + 2;
    }else if(value.length>=4){
      patternSize = value.length + 1;
    }else{
      patternSize = value.length;
    }
    let patternShort = pattern.substring(0,patternSize);
    const v = value.toString();
    return patternShort.replace(/#/g, _ => v[i++]);
  }
  
  maskStringExceptLast(str : String, unmaskedLength = 4, maskChar = '*') {
    if (str === null || str === undefined) {
      return ''; 
    }
    const stringValue = String(str).substring(0,16);
    const totalLength = 16;
    const maskCharLength = str.length >= (totalLength-unmaskedLength) ? (totalLength-unmaskedLength) : str.length;
    const maskedPart = maskChar.repeat(maskCharLength);
    let unmaskedPart = '';
    if(str.length - (totalLength-unmaskedLength) > 0){
      unmaskedPart = stringValue.slice(totalLength-unmaskedLength);
    }

    return this.format(maskedPart + unmaskedPart,'#### #### #### ####');
  }

  confirmDeleteFunc(card: ICreditCardDTO) {
    this.confirmDelete.emit(card)
  }

}
